import React from 'react';

import{ Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import '../utils/fonts';

// E5E7EB

const ReportsToPDF = ({data, reportType}) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={{ marginBottom: 10, backgroundColor: 'rgb(243 244 246)', padding: 6}}>
          <Text style={{fontSize: 17, fontFamily: 'Open Sans', fontWeight: 700, marginBottom: 8}}>{reportType}</Text>
          <View style={{display: 'flex', flexDirection: 'row'}}>
            <View style={{marginRight: 20, flex: 0.6}}>
              <Text style={{fontSize: 7, color: 'black', marginBottom: 2}}>As of March 24, 2023</Text>
              <Text style={{fontSize: 7}}>Caspian Outlets Limited</Text>
            </View>
            <View style={{display: 'flex', flex:1, justifyContent: 'center'}}>
              <Text style={{fontSize: 7, color: 'black', marginBottom: 2}}>Journals: All</Text>
              <Text style={{fontSize: 7}}>Analytic Accounts: All</Text>
            </View>
          </View>
        </View>
        {data.map((report, idx) =>
          <View key={idx} style={styles.section}>
            <View style={styles.sectionHeaderContainer}>
              <Text style={styles.sectionHeader}>{report.name}</Text>
              <Text style={styles.sectionHeader}><Text style={{fontSize: 7}}>GH¢</Text> {report.balance}</Text>
            </View>
              {report.sub.map((subAccount, id) => 
                <View key={id} style={styles.sectionSubHeaderContainer}>
                  {/* {subAccount.subAccounts ?  */}
                    <View style={{marginBottom: 4}}>
                      {/* {subAccount.subAccounts.map((account, ids) =>  */}
                        <View key={id}>
                          <View style={{flexDirection: 'row', justifyContent:'space-between', borderBottomColor: '#d3d3d3', borderBottomWidth: 1}}>
                            <Text style={styles.subHeader}>{subAccount.name}</Text>
                            <Text style={{ fontSize: 6, }}><Text style={styles.ghsymbol}>GH¢</Text> {subAccount.balance}</Text>
                          </View>
                          {subAccount.account.map(children =>
                            <View style={{flexDirection: 'row', marginLeft: 8, justifyContent:'space-between', borderBottomColor: '#d3d3d3', borderBottomWidth: 1}}>
                              <Text style={styles.textContent}>{children.name}</Text>
                              <Text style={{ fontSize: 5, }}><Text style={styles.textContent}>GH¢</Text> {children.amount}</Text>
                            </View>

                          )}
                        </View>                        
                      {/* )} */}
                    </View>
                    {/* :
                    <View style={{flexDirection: 'row', justifyContent:'space-between', borderBottomColor: '#d3d3d3', borderBottomWidth: 1}}>
                      <Text style={styles.subHeader}>{subAccount.name}</Text>
                      <Text style={{ fontSize: 6, }}><Text style={styles.ghsymbol}>GH¢</Text> {subAccount.balance}</Text>
                    </View> */}
                  {/* } */}
                </View>
              )}
          </View>
        )}
      </Page>
    </Document>
  )
};

const styles = StyleSheet.create({
  page: {
    backgroundColor: 'white',
    paddingHorizontal: 50,
    paddingTop: 25
  },
  section: {
    marginBottom: 12,
  },
  sectionHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: 1,
    borderBottomColor: 'black',
  },
  sectionHeader: {
    fontSize: 7,
    fontFamily: 'Open Sans',
    fontWeight: 'semibold'
  },
  sectionSubHeaderContainer: {
    marginLeft: 8
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: 8
  },
  subHeader: {
    fontSize: 6, 
    fontFamily: 'Open Sans',
    // fontWeight: 'bold'
  },
  textContent: {
    fontSize: 5, 
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    color: 'black'
  },
  ghsymbol: {
    fontSize: 5,
    fontFamily: 'Open Sans',
    // fontWeight: 300
  }
});


export default ReportsToPDF;